import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import LeaderboardModule from '@/modules/leaderboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/leaderboard/')({
  component: LeaderboardPage,
});

function LeaderboardPage() {
  const { canAccessGlobalLeaderboard } = useAccessControl();

  if (!canAccessGlobalLeaderboard) {
    return <AccessDenied />;
  }

  return <LeaderboardModule />;
}
